var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSfpDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1347,
    height: 1344,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1680 -324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1961 960 2754.21 960",
    stroke: "#000000",
    strokeWidth: 45.8333,
    strokeMiterlimit: 8,
    strokeDasharray: "45.8333 45.8333",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1961 1031 2754.21 1031",
    stroke: "#000000",
    strokeWidth: 45.8333,
    strokeMiterlimit: 8,
    strokeDasharray: "45.8333 45.8333",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1737.5,
    y: 615.5,
    width: 1232,
    height: 759,
    stroke: "#000000",
    strokeWidth: 114.583,
    strokeMiterlimit: 8,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1957,
    y: 1281,
    width: 793,
    height: 192
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1961.5 994.5 2740.3 994.5",
    stroke: "#000000",
    strokeWidth: 68.75,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSfpDark);
export default __webpack_public_path__ + "static/media/sfp_dark.88bb2ef1c704961dc38ef31d281bb922.svg";
export { ForwardRef as ReactComponent };